<template>
    <div
        class="header-dom"
        :style="{
            backgroundColor: bg,
            position: position,
            top: top,
        }"
        v-if="showInput"
    >
        <div
            v-if="hideCover"
            class="cover"
            :style="{ backgroundColor: coverBg || bg }"
        ></div>
        <header
            id="head_top"
            class="common-header"
            :style="{ backgroundColor: bg == '#0152b4' ? '#3766e1' : bg }"
        >
            <slot name="head_left"></slot>
            <a
                v-if="!this.$slots.head_left || imLeft"
                class="common-header_left"
                @click="$router.back()"
            />
            <section class="common-title_head" v-if="headTitle">
                <span
                    class="common-title_text ellipsis"
                    :style="{ color: color }"
                    >{{ headTitle }}</span
                >
            </section>
            <div class="common-title_head" v-if="showInput">
                <input
                    type="text"
                    class="common-title_select_Input"
                    maxlength="20"
                    v-model="key_word"
                    ref="key_word"
                    :placeholder="placeholderText"
                />
                <div
                    class="common-title_select_text"
                    @click="clickSearch"
                >
                    <span class="common-title_select_text_se">搜索</span>
                </div>
            </div>
            <section class="common-title_center">
                <slot name="head_center"></slot>
            </section>
            <section class="common-header_right">
                <slot name="head_right"></slot>
            </section>
        </header>
    </div>
</template>

<script>
/*
 * @name: 导航头部
 * @description:导航头部，headTitle 标题  bg 背景图片
 * @author: zefeng(zefeng.chen@shengyc.com)
 * @Date: 2019-05-13 13:57:16
 * @LastEditTime: 2019-05-13 13:57:16
 */

import { isWeiXin } from '@/config/Utils';
import { deepClone } from '@/config/Utils'

export default {
    created() {
        document.title = this.inputHeadTitle || this.headTitle;
        this.hideCover = isWeiXin();
    },
    data() {
        return {
            hideCover: '',
            key_word:'',
        };
    },
    props: {
        fromScreen: {
            type: String,
        },
        //当输入框时placeholder的值
        placeholderText: {
            type: String,
        },
        //当展示输入框时标题的值
        inputHeadTitle: {
            type: String,
        },
        //表头是否展示输入框
        showInput: {
            type: Boolean,
            default: false,
        },
        imLeft: {
            type: Boolean,
            default: false,
        },
        // key_word: {
        //     type: String,
        //     default: '4',
        // },
        position: {
            type: String,
            default: 'relative',
        },
        headTitle: {
            type: String,
        },
        coverBg: {
            type: String,
        },
        bg: {
            type: String,
            default: '#ffffff',
        },
        color: {
            type: String,
            default: '#0152b4',
        },
        top: {
            type: String,
            default: '0',
        },
    },
    methods:{
        clickSearch(){
            const q_name=deepClone(this.key_word)
            this.$emit('clickSearch',q_name)
        }
    }
};
</script>

<style lang="scss">
@import '../../assets/style/mixin';

.cover {
    width: 100vw;
    top: 0;
    z-index: 9;
}

#head_top {
    background-color: $blue;
    position: relative;
    z-index: 100;
    left: 0;
    top: 0;
    @include wh(100vmin, vw(44));
}
.header-dom {
    z-index: 999;
}
.common-header {
    display: flex;
    padding-right: vw(8);
    padding-left: vw(8);
    align-items: center;
}
.common-header_left {
    display: block;
    @include wh(vw(44), vw(44));
    background: transparent url('../../assets/images/left_arrow2.png') no-repeat
        center center;
    background-size: vw(10), vw(18);
}
.common-title_center {
    @include center;
}
.common-header_right {
    position: absolute;
    right: vw(8);
    top: 0;
}
.common-title_head {
    padding: 0;
    display: block;
    // @include center;
    width: 50%;
    color: #fff;
    height: vw(44);
    text-align: center;
    flex-direction: row;

    .common-title_text {
        @include sc(vw(16), #0152b4);
        height: vw(44);
        line-height: vw(44);
        text-align: center;
        font-weight: bold;
        @include center;
        padding-left:vw(10)
    }
    .common-title_select_Input {
        @include center;
        background-color: rgba(255, 255, 255, 0.15);
        height: vw(30);
        border-radius: vw(15);
        width: vw(260);
        padding-left: vw(20);
        padding-right: vw(20);
    }
    .common-title_select_Input::-webkit-input-placeholder {
        color: rgba(255, 255, 255, 0.5);
    }
    .common-title_select_text {
        position: absolute;
        right: vw(10);
        justify-content: center;
        height: vw(44);
        @include fja('flex-end', center);
        .common-title_select_text_se {
            font-size: vw(16);
            color: '#fff';
        }
    }
}
.common-title_headkey {
    display: flex;
    flex-direction: row;
}
// @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
//   .cover {
//     height: vw(30);
//   }
// }

// @media screen and (orientation: landscape) {
//   .cover {
//     width: 100vw;
//     top: 0;
//     z-index: 9;
//   }

//   #head_top {
//     background-color: $blue;
//     position: relative;
//     z-index: 100;
//     left: 0;
//     top: 0;
//     @include wh(100%, vh(44));
//   }
//   .header-dom {
//     z-index: 999;
//   }
//   .common-header {
//     display: flex;
//     padding-right: vh(8);
//     padding-left: vh(8);
//     align-items: center;
//   }
//   .common-header_left {
//     display: block;
//     @include wh(vh(44), vh(44));
//     background: transparent url('../../assets/images/left_arrow2.png') no-repeat
//       center center;
//     background-size: vh(10), vh(18);
//   }
//   .common-title_center {
//     @include center;
//   }
//   .common-header_right {
//     position: absolute;
//     right: vh(8);
//     top: 0;
//   }
//   .common-title_head {
//     padding: 0;
//     display: block;
//     @include center;
//     width: 50%;
//     color: #fff;
//     height: vh(44);
//     text-align: center;
//     .common-title_text {
//       @include sc(vh(16), #0152b4);
//       height: vh(44);
//       line-height: vh(44);
//       text-align: center;
//       font-weight: bold;
//       @include center;
//     }
//   }
// }
</style>
